"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeOverrideIncompatible = void 0;
function typeOverrideIncompatible() {
    return function (source, override) {
        return {
            ...source,
            ...override
        };
    };
}
exports.typeOverrideIncompatible = typeOverrideIncompatible;
//# sourceMappingURL=typeOverrideIncompatible.js.map